var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useMessage } from './useMessage';
import { authSlice } from '../redux/reducers/AuthSlice';
import { useTypeDispatch } from './useTypeDispatch';
import { isReportJournal } from '../redux/reducers/IsReportJournal';
import { isReportAdmission } from '../redux/reducers/IsReportAdmission';
import { useTypeSelector } from './useTypeSelector';
import { showErrorModal } from '../redux/reducers/requestErrModalSlice';
import { useTranslation } from 'react-i18next';
export const basesUrl = process.env.NODE_ENV == 'development' ? 'http://localhost:3157/api' : '/avnvm/api';
// Default error response object
const DEFAULT_ERROR_RESPONSE = {
    auth: false,
    type: 'error',
    message: 'Request failed',
    data: null
};
export const useHttp = () => {
    const toast = useMessage();
    const [loader, setLoader] = React.useState(false);
    const { clearData } = authSlice.actions;
    const { hideJournalReport } = isReportJournal.actions;
    const { hideAdmissionReport } = isReportAdmission.actions;
    const { is: isJournal } = useTypeSelector(state => state.isJournalReducer);
    const { is: isAddiss } = useTypeSelector(state => state.isAdmissionReducer);
    const dispatch = useTypeDispatch();
    const { t } = useTranslation();
    const request = React.useCallback((url, method = 'GET', body = null, headers = {}, options = {}) => __awaiter(void 0, void 0, void 0, function* () {
        const { silent = false } = options;
        try {
            setLoader(true);
            if (body) {
                body = JSON.stringify(body);
                headers['Content-Type'] = 'application/json';
            }
            const res = yield fetch(basesUrl + url, { method, body, headers, credentials: 'include' });
            /**
             * Ответ самого входа — не событие сессии.
             *
             * На неверный пароль AuthController отвечает кодом 303 и
             * сообщением «Неверный логин или пароль!». Ниже 303 означает
             * «сессия кончилась»: клиент сбрасывал авторизацию и подменял
             * ответ строкой «Unauthorized» — её человек и видел вместо
             * причины, да ещё по-английски. На входе сессии ещё нет,
             * сбрасывать нечего, а текст сервера уже переведён им самим
             * через req.t(). Пропускаем такой ответ к обычному разбору.
             */
            const isLoginAnswer = res.status === 303 && url.split('?')[0] === '/auth/login';
            // Handle 401 Unauthorized BEFORE parsing JSON
            if (!isLoginAnswer && (res.status === 401 || res.status === 303)) {
                dispatch(clearData());
                if (isJournal) {
                    dispatch(hideJournalReport());
                }
                if (isAddiss) {
                    dispatch(hideAdmissionReport());
                }
                return Object.assign(Object.assign({}, DEFAULT_ERROR_RESPONSE), { message: 'Unauthorized' });
            }
            // Handle error statuses BEFORE trying to parse JSON
            if (!isLoginAnswer && !res.ok) {
                console.error(`Error: ${res.status}`);
                if (!silent) {
                    // Сервер ответил — значит связь есть. Текст про интернет тут врал
                    // и уводил диагностику в сторону (кейс КНАУ 09.09.2026).
                    dispatch(showErrorModal(t('serverErrorText', { code: res.status })));
                }
                return Object.assign(Object.assign({}, DEFAULT_ERROR_RESPONSE), { message: `Server error: ${res.status}` });
            }
            // Handle 304 Not Modified
            if (res.status === 304) {
                return Object.assign(Object.assign({}, DEFAULT_ERROR_RESPONSE), { type: 'not_modified' });
            }
            // Only parse JSON for successful responses
            let data;
            try {
                data = yield res.json();
            }
            catch (parseError) {
                /* Сервер ответил, но не данными. Почти всегда это страница
                   приложения вместо ответа: клиент зовёт адрес, которого на
                   сервере ещё нет — версии разошлись. Говорить тут «нет
                   соединения» значит уводить поиск в сеть, где всё в порядке. */
                console.error('Failed to parse JSON response:', parseError);
                if (!silent) {
                    dispatch(showErrorModal(t('badAnswerText')));
                }
                return Object.assign(Object.assign({}, DEFAULT_ERROR_RESPONSE), { message: 'JSON parse error' });
            }
            return data;
        }
        catch (e) {
            console.error('Request failed:', e);
            if (!silent) {
                dispatch(showErrorModal(t('warningText')));
                // toast('Ошибка в сервере', 'error')
            }
            return Object.assign(Object.assign({}, DEFAULT_ERROR_RESPONSE), { message: e instanceof Error ? e.message : 'Network error' });
        }
        finally {
            setLoader(false);
        }
    }), [dispatch, isJournal, isAddiss, toast]);
    return { request, loader };
};
